import gql from 'graphql-tag';

export default gql`
  query GetBellyLoadAllocatedBoxes($loadId: Int) {
    getBellyLoadAllocatedBoxes(loadId: $loadId) {
      id
      index
      loadId
      jobId
      boxId
      proppantId
      boxDesc
      allocationWeight
      isBoxAllocated
      isLoadAllocated
    }
  }
`;